import React, { useState } from "react";

export const FAQ = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? -1 : index);
  };

  return (
    <div id="faq" className="faq-section">
      <div className="container">
        <div className="section-title text-center">
          <h2>Frequently Asked Questions</h2>
          <p>
            Find answers to common questions about selling gold at AHVI Gold.
            Contact us if you have any other questions!
          </p>
        </div>

        <div className="row">
          <div className="col-md-8 col-md-offset-2">
            <div className="faq-accordion">
              {props.data
                ? props.data.map((item, i) => (
                    <div key={i} className="faq-item">
                      <div
                        className={`faq-question ${
                          activeIndex === i ? "active" : ""
                        }`}
                        onClick={() => toggleAccordion(i)}
                        style={{
                          cursor: "pointer",
                          padding: "15px 20px",
                          backgroundColor:
                            activeIndex === i ? "#FFD700" : "#f8f9fa",
                          border: "1px solid #ddd",
                          marginBottom: "10px",
                          borderRadius: "4px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          transition: "all 0.3s ease",
                          fontWeight: "600",
                          color: activeIndex === i ? "#000" : "#333",
                        }}
                      >
                        <span>{item.question}</span>
                        <i
                          className="fa fa-chevron-down"
                          style={{
                            transform:
                              activeIndex === i ? "rotate(180deg)" : "rotate(0)",
                            transition: "transform 0.3s ease",
                          }}
                        ></i>
                      </div>
                      {activeIndex === i && (
                        <div
                          className="faq-answer"
                          style={{
                            padding: "15px 20px",
                            backgroundColor: "#fff",
                            border: "1px solid #ddd",
                            borderTop: "none",
                            marginBottom: "10px",
                            borderRadius: "0 0 4px 4px",
                            color: "#555",
                            lineHeight: "1.6",
                            animation: "slideDown 0.3s ease",
                          }}
                        >
                          {item.answer}
                        </div>
                      )}
                    </div>
                  ))
                : "Loading FAQ..."}
            </div>
          </div>
        </div>

        <div
          style={{
            textAlign: "center",
            marginTop: "40px",
            padding: "20px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
          }}
        >
          <h4 style={{ marginBottom: "10px" }}>Still have questions?</h4>
          <p style={{ marginBottom: "15px" }}>
            Contact us directly for personalized assistance with your gold selling needs.
          </p>
          <a href="#contact" className="btn btn-custom">
            Contact Us
          </a>
        </div>
      </div>

      <style>{`
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};
